import { RequestActionTypes } from './request.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    createRequestSuccess: null,
    createRequestError: null,
    createRequestReqStatus: '',
    requestListSuccess: null,
    requestListError: null,
    requestDetailSuccess: null,
    requestDetailError: null,
    updateRequestStatusSuccess: null,
    updateRequestStatusError: null,
    updateRequestStatusReqStatus: ''
}

const requestReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RequestActionTypes.CREATE_REQUEST_REQ_SUCCESS:
            return {
                ...state,
                createRequestSuccess: action.payload,
                createRequestError: null,
                createRequestReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case RequestActionTypes.CREATE_REQUEST_REQ_ERROR:
            return {
                ...state,
                createRequestSuccess: null,
                createRequestError: action.payload,
                createRequestReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case RequestActionTypes.CREATE_REQUEST_REQ_STATUS:
            return {
                ...state,
                createRequestReqStatus: ''
            }
        case RequestActionTypes.REQUEST_LIST_REQ_SUCCESS:
            return {
                ...state,
                requestListSuccess: action.payload,
                requestListError: null
            }
        case RequestActionTypes.REQUEST_LIST_REQ_ERROR:
            return {
                ...state,
                requestListSuccess: null,
                requestListError: action.payload
            }
        case RequestActionTypes.REQUEST_DETAIL_REQ_SUCCESS:
            return {
                ...state,
                requestDetailSuccess: action.payload,
                requestDetailError: null
            }
        case RequestActionTypes.REQUEST_DETAIL_REQ_ERROR:
            return {
                ...state,
                requestDetailSuccess: null,
                requestDetailError: action.payload
            }
        case RequestActionTypes.UPDATE_REQUEST_STATUS_REQ_SUCCESS:
            return {
                ...state,
                updateRequestStatusSuccess: action.payload,
                updateRequestStatusError: null,
                updateRequestStatusReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case RequestActionTypes.UPDATE_REQUEST_STATUS_REQ_ERROR:
            return {
                ...state,
                updateRequestStatusSuccess: null,
                updateRequestStatusError: action.payload,
                updateRequestStatusReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case RequestActionTypes.UPDATE_REQUEST_STATUS_REQ_STATUS:
            return {
                ...state,
                updateRequestStatusReqStatus: ''
            }
        case RequestActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default requestReducer